/**
 * @typedef {import('../../../shared/index.d.ts').ApiUserData} ApiUserData
 * @typedef {import('../../../shared/index.d.ts').UserToken} UserToken
 */
/**
 * @returns {Promise<ApiUserData>}
 */
export const callFetchUserDataApi = async () => {
  return (await fetch('/api/user')).json();
};

/**
 * @returns {Promise<UserToken>}
 */
export const callFetchTokenApi = async () => {
  return (await fetch('/api/token')).json();
};

/**
 * @returns {Promise<UserToken>}
 */
export const callFetchRefreshTokenApi = async () => {
  return (await fetch('/api/token/refresh')).json();
};
